<template>
  <div>
    <router-link v-if="withTopLink" class="stretched-link" :to="{name:'Top'}">
      <img src="/img/logo.png" alt="NOES 重調@CITY">
    </router-link>
    <div v-else>
      <img src="/img/logo.png" alt="NOES 重調@CITY">
    </div>
  </div>
</template>

<script>
export default {
  name: "Logo",
  props: {
    withTopLink: {
      type: Boolean,
      default: true,
    },
  }
}
</script>
